import { z } from 'zod'

import { LocalizedValueZod } from '../localization'
import { PromotionPlacementZod } from '../promotions/promotions-zod'

export const PromotionCampaignPlacementZod = z.object({
  fee: z.number(),
  suggestedPrice: LocalizedValueZod,
})
export type PromotionCampaignPlacement = z.infer<typeof PromotionCampaignPlacementZod>

export const PromotionCampaignZod = z.object({
  year: z.number(),
  placements: z.record(PromotionPlacementZod, PromotionCampaignPlacementZod).nullish().default({}),
})
export type PromotionCampaign = z.infer<typeof PromotionCampaignZod>

export const ConfigurationPromotionsZod = z.object({
  initiativeId: z.string().optional(),
  autoPlayDelay: z.number().optional().default(8),
  campaigns: z.record(z.string(), PromotionCampaignZod).nullish().default({}),
})
